import styled from 'styled-components';

import { Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { InputValueBoxBaseStyle } from '../../theme';
import { Icon } from '../icon/icon.component';

import { DropdownOptionsProps } from './dropdown.types';

export const Container: StyledComponent<'div'> = styled.div`
  position: relative;
`;

export const InputContainer: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  ${InputValueBoxBaseStyle}
  position: relative;
`;

export const Value: StyledComponent<'span'> = styled.span`
  width: calc(100% - 60px);
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${Color.Black};
`;

export const DropdownOptions: StyledComponent<'div', DropdownOptionsProps> = styled.div<DropdownOptionsProps>`
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  right: 0;
  border: 1px solid ${Color.Stroke};
  transition: 0.3s;
  max-height: ${({ $visible }: DropdownOptionsProps) => $visible ? '150px' : '0'};
  overflow: ${({ $visible }: DropdownOptionsProps) => $visible ? 'auto' : 'hidden'};
  background-color: ${Color.White};
  z-index: ${({ $visible }: DropdownOptionsProps) => $visible ? ZIndex.Dropdown : ZIndex.Hidden};
`;

export const DropdownOptionItem: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  padding: 18px 16px;
  display: block;
  width: 100%;
  text-align: left;

  &:hover {
    background-color: ${Color.Gray100};
  }
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  position: absolute;
  right: 19px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 10px;
`;
